var xP = require('../../xP');

module.exports = {
  name: 'repeat_append_button', base: 'button', prototype: {
    element_selector: '.repeat_append_button',

    init: function (params) {
      xP.controls.repeat_append_button.base.init.apply(this, arguments);

      var parent = this.parent(), repeat = parent.repeat;

      if (!(repeat instanceof xP.repeats.item)) {
        return;
      }

      this.$element.click(function () {
        repeat.append(parent);

        return false;
      });

      this.enabled = {
        on: function () {
          return repeat.val() < repeat.max
        }, from: repeat
      };
    }
  }
};



/*****************
 ** WEBPACK FOOTER
 ** ./lib/controls/repeats/repeat_append_button.js
 ** module id = 27
 ** module chunks = 0
 **/